/**
 * Tipos do bounded context de acessibilidade.
 *
 * Cobre F1-F6 da Proposta Lume:
 * - F1: WCAG 2.2 AA (validado nos tokens + checagens runtime)
 * - F2: leitor de tela nativo (preferências OS respeitadas; ARIA semântico)
 * - F3: voz para tudo (composables de TTS/STT)
 * - F4: fonte ajustável + OpenDyslexic
 * - F5: alto contraste + modos de daltonismo
 * - F6: slow mode (transições + timeouts estendidos)
 *
 * Constitucional:
 * - P-UX-01 (Calm by default): todas as preferências são opt-in.
 * - P-UX-04 (Accessibility first): preferir `prefers-*` do OS como default.
 * - Princípio X (Dignidade): sem paternalismo; sem "modo especial" implícito.
 */

export type FontSize = "small" | "medium" | "large" | "x-large";
export type FontFamily = "system" | "dyslexic";
export type ColorMode = "system" | "light" | "dark";
export type ContrastMode = "normal" | "high";
export type ColorblindMode = "none" | "protanopia" | "deuteranopia" | "tritanopia";
export type MotionMode = "system" | "reduced" | "full";
export type SlowMode = "off" | "on";

export interface AccessibilityPreferences {
  fontSize: FontSize;
  fontFamily: FontFamily;
  colorMode: ColorMode;
  contrastMode: ContrastMode;
  colorblindMode: ColorblindMode;
  motionMode: MotionMode;
  slowMode: SlowMode;
  voiceInputEnabled: boolean;
  voiceOutputEnabled: boolean;
  voiceRate: number; // 0.5..2.0 (1.0 = normal)
  voicePitch: number; // 0.5..2.0
}

export const DEFAULT_PREFERENCES: AccessibilityPreferences = {
  fontSize: "medium",
  fontFamily: "system",
  colorMode: "system",
  contrastMode: "normal",
  colorblindMode: "none",
  motionMode: "system",
  slowMode: "off",
  voiceInputEnabled: false,
  voiceOutputEnabled: false,
  voiceRate: 1.0,
  voicePitch: 1.0,
};
